const data = {
  "logo": {
    "linkDescription": "Terug naar de Coolblue homepage"
  },
  "categoryNavigation": {
    "title": "Bekijk alle <strong>categorieën</strong>",
    "ariaLabel": "Bekijk alle categorieën"
  },
  "hamburgerMenu": {
    "assortment": "Ons assortiment",
    "business": " Zakelijk",
    "childrenDirectLink": "Naar {{- title }}",
    "customerService": "Klantenservice",
    "label": "Hamburger menu",
    "myCoolblue": "Mijn Coolblue",
    "title": "Menu",
    "allCategories": "Alle categorieën",
    "selectedLanguage": "Taal: {{language}}",
    "language": "Taal"
  },
  "account": {
    "accountName": "Account",
    "login": "Inloggen",
    "noAccount": "Nog geen account?",
    "startHere": "Start hier",
    "factLoggedIn": "Welkom",
    "sloganLoggedIn": "Leuk dat je er bent.",
    "sloganLoggedOut": "Welkom terug.",
    "myCoolblueLoggedIn": "Overzicht van",
    "myCoolblue": "Mijn Coolblue",
    "ordersAndInvoices": "Bestellingen en facturen",
    "returns": "Retouren en reparaties",
    "preference": "Gegevens en voorkeuren",
    "credit": "Tegoeden",
    "discount": "Kortingen",
    "wishlist": "Verlanglijstje",
    "energy": "Mijn Coolblue Energie",
    "logout": "Uitloggen"
  },
  "header": {
    "wishlistIcon": "Verlanglijst",
    "shoppingCartIcon": "Winkelmandje",
    "navigationAriaLabel": "Menu",
    "sinterklaasCampaignTitle": "Win je verlanglijstje",
    "business": "Zakelijk",
    "stores": "Winkels",
    "contact": "Klantenservice",
    "aboutCoolblue": "Over Coolblue",
    "communities": {
      "myHomeOfficeStore": "Mijn Thuiswerkwinkel",
      "myCYODStore": "Mijn Choose Your Own Device Winkel",
      "myChristmasStore": "Mijn Kerstwinkel",
      "myBackToSchoolStore": "Mijn Back to School Winkel",
      "myGiftStore": "Mijn Cadeauwinkel",
      "myVitalityStore": "Mijn Vitaliteitswinkel",
      "myDigisprongStore": "Mijn Digisprongwinkel",
      "myPurchasingPortal": "Mijn Inkoopportaal",
      "myBlueBuiltStore": "Mijn BlueBuilt Winkel",
      "myBYODStore": "Mijn Bring Your Own Device Winkel",
      "myCafetariaplan": "Mijn Cafetariaplan",
      "myCompanyStore": "Mijn Bedrijfswinkel"
    }
  },
  "typeahead": {
    "defaultSuggestionText": "Zoeken naar {{query}}",
    "previouslySearchedByYou": "Eerder door jou gezocht",
    "popularSearchEntries": "Populaire zoektermen",
    "relevantPages": "Relevante pagina's",
    "relevantProducts": "Relevante producten",
    "bestSoldProducts": "Best verkocht",
    "youMayLike": "Interessant voor jou"
  },
  "introductionHeader": {
    "title": "Hallo Duitsland",
    "fact": "Coolblue",
    "slogan": "Alles voor een glimlach",
    "description": {
      "long": "Ons doel is om jou helemaal gelukkig te maken. Daarom hebben we ons eigen bezorgnetwerk, fietskoeriers, installateurs en winkels. Al meer dan 25 jaar laten we klanten glimlachen in Nederland, België en nu ook in Duitsland.",
      "short": "Coolblue zit al meer dan 25 jaar in Nederland, België en nu Duitsland."
    },
    "close": "Sluit",
    "link": "Leer ons beter kennen",
    "imageAlt": "Coolblue medewerker"
  },
  "salesPrice": {
    "prefix": "Adviesprijs"
  }
};

export default data;